//import { HTTP } from '@ionic-native/http/ngx';

import React, { useState, useContext } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';


import UserLogin from '../pages/zPublic/views/clientLogin';



import { Auth_ClientID_context } from '../storeState/auth_clientID_context'

import { Plugins } from '@capacitor/core';

const { Storage } = Plugins;

async function removeStorageCredentials() {


    await Storage.remove({ key: 'accountID' });
    await Storage.remove({ key: 'employeeID' });
    await Storage.remove({ key: 'schemaName' });
    await Storage.remove({ key: 'isAuthenticated' });
    await Storage.remove({ key: 'accessRights' });

}

/*async function removeCookie(event) {

    //await Storage.remove({ key: 'userCookie' });

    //let cookie = new Cookie();

    cookie.remove(event)
}*/

export function PrivateRoute_client (props) {
//export class PrivateRoute extends React.Component {
//const PrivateRoute: React.FC = () => {


    let authClient_objects = useContext(Auth_ClientID_context);

    let [validation, setValidation ] = useState(false);
    let [acctID, setAccountID ] = useState(authClient_objects.acctID);
    let [schema, setSchema ] = useState(authClient_objects.schema);
    //let [cookieID, setCookie ] = useState(false);
    let [baseURL, setBaseURL ] = useState(authClient_objects.baseURL);

        let requestOptions = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
            },
            body: JSON.stringify({
                user: authClient_objects.acctID,
                schema: authClient_objects.schema

            })
        }

        fetch(baseURL+'authSession', requestOptions)
        .then(res => res.text())
        .then(res => {

            if(res == 1)
            {

                setValidation((prev) => { return true} );

                return true;
            }
            else if(res == 0)
            {
                removeStorageCredentials();
                setValidation(false);
            }
        }) 

    return  <React.Fragment>
                { validation == true ?  <Route path={props.path} component={props.render} /> :  <Route path="/clientLogin" component={UserLogin}/>}   
            </React.Fragment>

}
